import React from 'react';

export const SiteHeader: React.FC = () => {
  return (
    <header
      className="sticky top-0 left-0 right-0 z-50 border-b border-black/10"
      style={{ background: 'rgb(234, 88, 12)' }}
    >
      <div className="container flex items-center justify-between h-16 gap-4">
        <a href="/" className="flex items-center" aria-label="Inicio">
          <img
            src="/img/logo-header.png"
            alt="Jugar Hoy"
            width={139}
            height={61}
          />
        </a>
        <nav className="flex items-center gap-2 sm:gap-4 text-sm sm:text-base">
          <a
            href="/support"
            className="rounded-full bg-white/10 hover:bg-white/20 text-white px-3 py-1.5 sm:px-4 sm:py-2 font-semibold transition-colors"
          >
            Contacto
          </a>
        </nav>
      </div>
    </header>
  );
};
